function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(-867.753 -430.882)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35",
  "data-name": "Group 35",
  transform: "translate(891.805 475.279)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_73",
  "data-name": "Rectangle 73",
  width: 8.187,
  height: 21.205,
  transform: "translate(1.228)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34",
  "data-name": "Group 34",
  transform: "translate(0 2.885)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_32",
  "data-name": "Group 32",
  transform: "translate(0 11.667)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M932.342,575.5a.715.715,0,0,1-.784.614h-7.846a.716.716,0,0,1-.785-.614h0a.716.716,0,0,1,.785-.614h7.846a.715.715,0,0,1,.784.614Z",
  transform: "translate(-922.313 -574.882)",
  fill: "#fdc00f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M932.07,578.2a.855.855,0,0,1-.887.819h-8.869a.855.855,0,0,1-.887-.819h0a.855.855,0,0,1,.887-.819h8.869a.855.855,0,0,1,.887.819Z",
  transform: "translate(-921.427 -576.359)",
  fill: "#f9b233"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  "data-name": "Group 33"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M932.342,550.5a.715.715,0,0,1-.784.614h-7.846a.716.716,0,0,1-.785-.614h0a.716.716,0,0,1,.785-.614h7.846a.715.715,0,0,1,.784.614Z",
  transform: "translate(-922.313 -548.449)",
  fill: "#fdc00f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M932.07,547.2a.855.855,0,0,1-.887.819h-8.869a.855.855,0,0,1-.887-.819h0a.855.855,0,0,1,.887-.819h8.869a.855.855,0,0,1,.887.819Z",
  transform: "translate(-921.427 -546.382)",
  fill: "#f9b233"
})))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_74",
  "data-name": "Rectangle 74",
  width: 22.638,
  height: 7.596,
  rx: 3,
  transform: "translate(885.808 492.35)",
  fill: "#fc0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(879.933 497.643)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_75",
  "data-name": "Rectangle 75",
  width: 34.387,
  height: 11.053,
  rx: 2,
  transform: "translate(0 0)",
  fill: "#3d9ae2"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37",
  transform: "translate(8.366 2.303)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_76",
  "data-name": "Rectangle 76",
  width: 17.654,
  height: 6.448,
  rx: 1,
  fill: "#63b5f5"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_36",
  "data-name": "Group 36",
  transform: "translate(2.277 1.126)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M931.527,602.8a.461.461,0,0,1-.46.461H918.888a.461.461,0,0,1-.461-.461h0a.461.461,0,0,1,.461-.461h12.179a.461.461,0,0,1,.46.461Z",
  transform: "translate(-918.427 -602.342)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M931.527,606.8a.461.461,0,0,1-.46.461H918.888a.461.461,0,0,1-.461-.461h0a.461.461,0,0,1,.461-.46h12.179a.461.461,0,0,1,.46.46Z",
  transform: "translate(-918.427 -604.705)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M931.527,610.8a.461.461,0,0,1-.46.461H918.888a.461.461,0,0,1-.461-.461h0a.461.461,0,0,1,.461-.461h12.179a.461.461,0,0,1,.46.461Z",
  transform: "translate(-918.427 -607.067)",
  fill: "#fff"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_45",
  "data-name": "Group 45",
  transform: "translate(871.274 430.882)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41",
  transform: "translate(0 9.732)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M884.5,479.106c-3.19-4.1-12.132-11.2-13.09-16.168s3.379-7.1,9.5-8.282",
  transform: "translate(-871.274 -454.656)",
  fill: "none",
  stroke: "#fdc00f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M894.054,511.025a1.969,1.969,0,1,1-1.968-1.893A1.932,1.932,0,0,1,894.054,511.025Z",
  transform: "translate(-882.404 -486.831)",
  fill: "#fdc00f"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(38.48)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M965.274,479.106c3.19-4.1,12.132-11.2,13.09-16.168s-3.379-7.1-9.5-8.282",
  transform: "translate(-965.274 -454.656)",
  fill: "none",
  stroke: "#fdc00f",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M973.054,511.025a1.969,1.969,0,1,1-1.968-1.893A1.932,1.932,0,0,1,973.054,511.025Z",
  transform: "translate(-967.544 -486.831)",
  fill: "#fdc00f"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  d: "M926.748,434.994,924.8,468.9a11.692,11.692,0,0,1-11.692,11.691h-7.4A11.691,11.691,0,0,1,894.012,468.9l-1.949-33.905",
  transform: "translate(-883.553 -433.311)",
  fill: "#ffd633"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_43",
  "data-name": "Group 43",
  transform: "translate(17.051 10.883)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_42",
  "data-name": "Group 42"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  cx: 8.801,
  cy: 13.1,
  rx: 8.801,
  ry: 13.1,
  fill: "none",
  stroke: "#fdc00f",
  strokeMiterlimit: 10,
  strokeWidth: 4.124
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 6.755,
  cy: 10.848,
  rx: 6.755,
  ry: 10.848,
  transform: "translate(2.047 2.252)",
  fill: "#f9b233"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_44",
  "data-name": "Group 44",
  transform: "translate(6.612)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M926.179,439.565A1.506,1.506,0,0,1,924.61,441H890.5a1.506,1.506,0,0,1-1.569-1.433h0a1.506,1.506,0,0,1,1.569-1.433H924.61a1.506,1.506,0,0,1,1.569,1.433Z",
  transform: "translate(-888.313 -435.164)",
  fill: "#fdc00f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M925.907,432.417a1.58,1.58,0,0,1-1.621,1.535H889.048a1.58,1.58,0,0,1-1.621-1.535h0a1.58,1.58,0,0,1,1.621-1.535h35.238a1.58,1.58,0,0,1,1.621,1.535Z",
  transform: "translate(-887.427 -430.882)",
  fill: "#f9b233"
}))));

var SvgRank1 = function SvgRank1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.738,
    height: 77.814,
    viewBox: "0 0 58.738 77.814",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRank1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rank-1.6edec3aa.svg";
export { ForwardRef as ReactComponent };